import React from 'react';
import Button from 'carbon-react/lib/components/button';
import { LoaderSpinner } from 'carbon-react/lib/components/loader-spinner';
import { FormattedMessage } from 'react-intl';

import { SyncDataCardDivider } from '../sync-data-card/sync-data-card-divider';
import * as styles from './sync-button-container.scss';

interface Props {
  onSyncClick: () => Promise<void>;
  isLoading: boolean;
}

export const SyncControlButtonContainer = ({ onSyncClick, isLoading }: Props) => {
  if (isLoading) {
    return (
      <div style={{ marginTop: 16 }} className={styles.nonInteractive}>
        <Button buttonType="primary" mt="16px" data-testid="syncing-button">
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <FormattedMessage id="predict.syncing" defaultMessage="Syncing..." />
            <LoaderSpinner size="extra-small" showSpinnerLabel={false} variant="inverse" />
          </span>
        </Button>
      </div>
    );
  }

  return (
    <div style={{ marginTop: 16 }}>
      <SyncDataCardDivider />
      <Button buttonType="secondary" iconType="sync" iconPosition="after" mt="16px" onClick={onSyncClick}>
        <FormattedMessage id="import.sync" defaultMessage="Sync" />
      </Button>
    </div>
  );
};
